import {slideToggle, slideHide} from "./slideBlock";

(function(){
    const selects = document.querySelectorAll('.select');
    const options = document.querySelectorAll('.select .select__item');
    const body = document.querySelector('body');


    if(selects) {
        selects.forEach((select) => {
            select.addEventListener('click', function(e) {
                e.stopPropagation();
                let option = this.querySelector('.select__options');

                slideToggle(option);
            });
        });


        body.addEventListener('click', function (e) {
            selects.forEach((select) => {
                if(e.target != select) {
                    let option = select.querySelector('.select__options');
                    slideHide(option);
                }
            });
        });
    }


    if(options) {
        options.forEach((option) => {
            option.addEventListener('click', function() {
                let placeholder = this.closest('.select').querySelector('.select__placeholder');
                let current_term =  this.getAttribute('data-term');

                placeholder.innerHTML = this.innerHTML;
                placeholder.setAttribute('data-term', current_term);
                placeholder.classList.add('select__placeholder_chosen');
            });
        });
    }
})();
